// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__2kQ0d","welcomeBox":"style__welcomeBox__DDhEc","logoTall":"style__logoTall__5e+Ie"};